#import "../fragments/lead-distribution-automation.graphql"

query GetLeadDistribution($id: ID!) {
    leadDistributionAutomation(id: $id) {
        ...LeadDistributionAutomation
    }
}
